export default "__VITE_ASSET__Dk6l__qQ__"